module.exports = __webpack_public_path__ + "static/media/statuspage-empty.320dfcb8.svg";